export default {
  firUser: {
    __typename: 'FireBaseUser',
    uid: null,
    email: null,
    password: null
  }
}
